<template>
    <zk-admin-table title="二级单位管理" :loading="loading" :table="table" @change="handleTableChange"
        @select="handleTableSelect">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button size="mini" icon="el-icon-search" circle @click="searchVisible = !searchVisible"></el-button>
                <el-button size="mini" icon="el-icon-refresh" circle @click="getData"></el-button>
                <!-- <el-button size="mini" icon="el-icon-download" circle @click="doDownLoad"></el-button> -->
                <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="handleAdd"
                    v-if="permission.subsidiary2_add"></el-button>
            </el-row>
        </template>
        <template v-slot:search>
            <search-form @search="handleSearch" v-show="searchVisible" />
        </template>
        <el-table-column type="index" label="序号" align="center"
            :index="(index) => { return (this.table.page - 1) * this.table.pageSize + index + 1 }" width="100" />
        <el-table-column align="left" v-for="(v, idx) in table.columns" :prop="v.field" :label="v.title" :width="v.width"
            :formatter="v.formatter" :key="idx">
        </el-table-column>
        <el-table-column prop="subsidiary_admin" align="left" label="管理员" width="">
            <template slot-scope="scope">
                <div>
                    <subsidiary_admin :ref="`subsidiary_admin_${scope.row.id}`" :sid="scope.row.id"
                        @add="handleAdminAdd(scope.row)" @edit="handleAdminUpdate" @delete="handleAdminDelete(scope.row)" />
                </div>
            </template>
        </el-table-column>
        <el-table-column  align="center" label="单位信息管理" width="200">
            <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleUpdate(scope.row)" icon="el-icon-edit"
                    v-if="permission.subsidiary2_edit"></el-button>
                <el-popconfirm :title="`确认删除[${scope.row.name}]吗？`" @confirm="handleDelete(scope.row)"
                    v-if="permission.subsidiary2_delete" style="margin-left:5px">
                    <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete"></el-button>
                </el-popconfirm>
            </template>
        </el-table-column>
        <template v-slot:dialog>
            <data-admin-form ref="dataAdminForm" :visible="dialogAdminVisible" :form="form" @close="dialogAdminClose"
                @update="getData" :isNew="isNew" />
            <data-form ref="dataForm" :visible="dialogVisible" :form="form" @close="dialogClose" @update="getData"
                :isNew="isNew" />
        </template>
    </zk-admin-table>
</template>

<script>
import SearchForm from './widgets/searchForm'
import DataForm from './widgets/dataForm'
import DataAdminForm from './widgets/dataAdminForm'
import subsidiary_admin from './widgets/subsidiary_admin'
import data from './data'

export default {
    name: 'company-subsidiary2',
    path: '/main/company/subsidiary2',
    components: {
        SearchForm,
        DataForm,
        DataAdminForm,
        subsidiary_admin
    },
    data() {
        return {
            loading: false,
            table: data.table,
            dialogVisible: false,
            dialogAdminVisible: false,
            searchVisible: true,
            downloadVisible: false,
            search: {},
            form: {},
            isNew: false,
            multipleSelection: [],
            permission: {}
        }
    },
    methods: {
        dialogAdminClose(row) {
            this.dialogAdminVisible = false
            this.getData()
            this.$refs[`subsidiary_admin_${this.form.ejdw_id}`].getData()
        },
        dialogClose(row) {
            this.dialogVisible = false
            this.getData()
        },
        doDownLoad() {
            this.downloadVisible = true
        },
        handleAdd() {
            this.form = { level: 2, patient: 0, name: '', remarks: '' }
            this.isNew = true
            this.dialogVisible = true
        },
        handleAdminAdd(row) {
            this.$refs['dataAdminForm'].activeName = 'first'
            this.form = {
                ejdw: row.name,
                ejdw_id: row.id,
                username: '',
                password: '',
                name: '',
                contact: '',
                remarks: ''
            }
            this.isNew = true
            this.dialogAdminVisible = true
        },
        handleSearch(e) {
            this.search = e
            this.table.page = 1
            this.getData()
        },
        handleTableChange(e) {
            this.table = e
            this.getData()
        },
        handleTableSelect(val) {
            this.multipleSelection = val
        },
        async handleAdminUpdate(row) {
            console.log(row)
            this.isNew = false
            var temp = JSON.stringify(row)
            this.form = JSON.parse(temp)
            this.dialogAdminVisible = true
        },
        async handleUpdate(row) {
            console.log(row)
            this.isNew = false
            var temp = JSON.stringify(row)
            this.form = JSON.parse(temp)
            this.dialogVisible = true
        },
        async handleDelete(row) {
            if (!row.id) {
                this.$message.error('请选择要删除的对象')
                return
            }
            const resp = await this.$http.delete(`/company/subsidiary/${row.level}/${row.id}`)
            if (resp.data.code != 200) {
                this.$message.error(resp.data.msg)
            } else {
                this.$message.success('删除成功')
            }
            this.getData()
        },
        async getData() {
            this.loading = true
            try {
                const resp = await this.$http.get(`/company/subsidiary?level=2&page=${this.table.page}&pageSize=${this.table.pageSize}`, { params: this.search })
                if (!resp.data) {
                    this.$message.error(resp.data.msg)
                } else {
                    this.table.data = resp.data.data.records
                    this.table.total = resp.data.data.total
                }
            } catch (e) {
                this.$message.error(e.message)
            }
            this.loading = false
        },
        async getPermission() {
            const resp = await this.$http.get('/permission')
            this.permission = resp.data
        }
    },
    mounted() {
        this.getPermission()
        this.getData()
    }
}
</script>
